import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { Route, useLocation, BrowserRouter, Switch } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';


import { AppConfig } from './AppConfig';


import { Login } from './componentes/login/Login';
import { Bienvenido } from './componentes/app/Bienvenido';

import Crud from './pages/Crud';
import EmptyPage from './pages/EmptyPage';
import TimelineDemo from './pages/TimelineDemo';

import PrimeReact from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';

import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'prismjs/themes/prism-coy.css';
import './assets/demo/flags/flags.css';
import './assets/demo/Demos.scss';
import './assets/layout/layout.scss';
import './App.scss';

const App = () => {
   

    useEffect(() => {
        document.documentElement.style.fontSize = 14 + 'px';
    }, [])

    return (
        <>
            <BrowserRouter>
                <Switch>
                    <Route path="/Nomifast" exact render={() => <Login />} />
                    <Route path="/Nomifast/bienvenido" component={Bienvenido} />
                </Switch>
            </BrowserRouter>
        </>
    );

}

export default App;